import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'

const IconAngelSVG = ({color, className, ...rest}) => {
    return (
        <svg {...rest} width="54.824" height="39.882" viewBox="0 0 54.824 39.882"
             className={classNames(['svg-icon svg-angel', className])}>
            <defs>
                <linearGradient id="svg-angel_a" x2="1" y2="1" gradientUnits="objectBoundingBox">
                    <stop offset="0" stopColor="#2c80ed"/>
                    <stop offset="0.216" stopColor="#1794ec"/>
                    <stop offset="0.6" stopColor="#32cccc"/>
                    <stop offset="1" stopColor="#32cccc"/>
                </linearGradient>
            </defs>
            <g transform="translate(-101.221 -171.971)">
                <g transform="translate(125.774 181.118)">
                    <path className="svg-angel_a" stroke={color} fillRule="evenodd" fill="url(#svg-angel_a)"
                          d="M325.816,254.986a1.759,1.759,0,0,0-1.759,1.759v17.829a1.759,1.759,0,0,0,1.759,1.759h5.321a1.759,1.759,0,0,0,1.759-1.759v-.2a1.759,1.759,0,0,1,3.011-1.248l2.7,2.7a1.759,1.759,0,0,0,1.248.517h3.757a1.759,1.759,0,0,0,1.759-1.759v-3.769a1.76,1.76,0,0,0-.516-1.248l-2.716-2.716a1.759,1.759,0,0,1,1.246-3.012h.222a1.759,1.759,0,0,0,1.759-1.759v-5.322a1.759,1.759,0,0,0-1.759-1.759Z"
                          transform="translate(-324.057 -254.986)"/>
                </g>
                <path className="svg-angel_b" fill="#0d2b42"
                      d="M127.047,211.853c-.453,0-.907,0-1.359-.007a11.13,11.13,0,0,1-4.963-1.29,11.824,11.824,0,0,1-3.4-2.665,13.365,13.365,0,0,1-2.231-3.5,14.619,14.619,0,0,1-1.1-3.9c-.082-.6-.108-.609-.428-.78-3.7-1.985-5.915-5.4-6.58-10.164-.15-1.06-.291-1.375-.794-1.768a12.825,12.825,0,0,1-4.557-7.5,17.829,17.829,0,0,1-.417-3.759c0-.009,0-.018,0-.027v-.023A4.422,4.422,0,0,1,105.639,172q1.646,0,3.293-.006l1.732,0c9.5-.017,19.165-.016,28.509-.015h7.851a9.032,9.032,0,0,1,9.022,9.022v21.816a9.04,9.04,0,0,1-9.03,9.03H130.435c-.561,0-1.122,0-1.684.006S127.621,211.853,127.047,211.853Zm-21.859-35.377a13.908,13.908,0,0,0,.318,2.917,8.849,8.849,0,0,0,3.134,5.258,6.03,6.03,0,0,1,2.278,4.342c.487,3.487,1.965,5.847,4.521,7.217a4.514,4.514,0,0,1,2.488,3.739,10.66,10.66,0,0,0,.8,2.842,9.4,9.4,0,0,0,1.566,2.468,7.821,7.821,0,0,0,2.242,1.768,7.213,7.213,0,0,0,3.2.854c.992.012,2.011.006,3,0,.568,0,1.137-.006,1.705-.006h16.579a5.069,5.069,0,0,0,5.064-5.063V180.994a5.061,5.061,0,0,0-5.055-5.055h-7.852c-9.342,0-19,0-28.5.015l-1.729,0q-1.652,0-3.3.006a.44.44,0,0,0-.319.134.453.453,0,0,0-.133.331c0,.009,0,.019,0,.028Z"
                      transform="translate(0 0)"/>
            </g>
        </svg>
    );
};

IconAngelSVG.propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

IconAngelSVG.defaultProps = {
    color: '#ffffff',
    className: '',
};

export default IconAngelSVG;